import MonitoringDashboard from '../pages/Monitoring/MonitoringDashboard';
import ExecutiveDashboard from '../pages/Executive-Dashboard/ExecutiveDashboard';
import LoginPage from '../pages/login/LoginPage';
import DashboardLayout from '../layouts/DashboardLayout';
import ProjectCategories from '../pages/Project-Report/ProjectCategories';
import ProjectList from '../pages/Project-Report/ProjectList';
import ProjectDetail from '../pages/Project-Report/ProjectDetail';
import ProductionDashboard from '../pages/ProductionDashboard/ProductionDashboard';
import TvMode from '../pages/ProductionDashboard/TvMode';
import LogisticAndStock from '../pages/LogisticAndStock';
import DigitalJobReport from '../pages/DigitalJob/DigitalJobReport';
import DigitalStrukReport from '../pages/DigitalJob/DigitalStrukReport';

export const routes = [
  { path: "/login", element: <LoginPage /> },
  {
    path: "/",
    element: <DashboardLayout />,
    children: [
      { index: true, element: <MonitoringDashboard /> },
      { path: "executive", element: <ExecutiveDashboard /> },
      { path: "project-report", element: <ProjectCategories /> },
      { path: "project-report/:categoryId", element: <ProjectList /> },
      { path: "project-report/:categoryId/:projectId", element: <ProjectDetail /> },
      { path: "production", element: <ProductionDashboard /> },
      { path: "logistic-stock", element: <LogisticAndStock /> },
      { path: "digital-job", element: <DigitalJobReport /> },
      { path: "digital-struk", element: <DigitalStrukReport /> },
    ],
  },
  { path: "/tv-production", element: <TvMode /> },
];
